import { render, staticRenderFns } from "./PaymentPickupDetails.vue?vue&type=template&id=b2d164c6&"
import script from "./PaymentPickupDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentPickupDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPickupDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports